var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blur-tab-overlay relative",style:({
    '--initial-tab-size': _vm.resolvedOptions.tabSize,
    '--hovered-tab-size': _vm.resolvedOptions.hoveredTabSize,
    '--transition-duration': _vm.resolvedOptions.transitionDuration,
    '--border-radius': _vm.resolvedOptions.borderRadius
  }),on:{"contextmenu":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"w-full h-full pointer-events-none select-none",staticStyle:{"min-height":"200px"}},[_vm._t("default")],2),_c('div',{staticClass:"blur-layer",class:_vm.resolvedOptions.tabPosition},[_c('div',{staticClass:"tab-layer",class:_vm.resolvedOptions.tabPosition})])])
}
var staticRenderFns = []

export { render, staticRenderFns }